export default {
  OPEN: 'open',
  PROGRESS: 'progress',
  PROGRESS_COMPLETE: 'progress_complete',
  REVIEWING: 'reviewing',
  REVIEWED: 'reviewed',
  FINISHED: 'finished',
  CLOSED: 'closed',
  ANONYMIZING: 'anonymizing',
  ANONYMIZED: 'anonymized',
  ARCHIVED: 'archived',
  DELETED: 'deleted',
};
